module.exports = __webpack_public_path__ + "media/images/article-types-doc-old-0d1eacb10d775eed67891c0ea334b306.png";